"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _IconWrapper = _interopRequireDefault(require("./IconWrapper"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Event = function Event(_ref) {
  var viewBox = _ref.viewBox;
  return /*#__PURE__*/_react.default.createElement(_IconWrapper.default, {
    viewBox: viewBox
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M9.21333 7.70018H11.1111V5.9C11.1111 5.40294 11.5091 5 12 5C12.4909 5 12.8889 5.40294 12.8889 5.9V7.70018H17.2578V6C17.2578 5.50294 17.6558 5.1 18.1467 5.1C18.6376 5.1 19.0356 5.50294 19.0356 6V7.70018H20.7867C22.0091 7.70018 23 8.76621 23 10.0812V20.6191C23 21.9341 22.0091 23.0002 20.7867 23.0002H9.21333C7.99094 23.0002 7 21.9341 7 20.6191V10.0812C7 8.76621 7.99094 7.70018 9.21333 7.70018Z",
    fill: "#E8F1FB"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M9.21333 9.50018C8.97278 9.50018 8.77778 9.71407 8.77778 9.97793V20.7224C8.77778 20.9863 8.97278 21.2002 9.21333 21.2002H20.7867C21.0272 21.2002 21.2222 20.9863 21.2222 20.7224V9.97793C21.2222 9.71407 21.0272 9.50018 20.7867 9.50018H9.21333ZM9.21333 7.70018H20.7867C22.0091 7.70018 23 8.76621 23 10.0812V20.6191C23 21.9341 22.0091 23.0002 20.7867 23.0002H9.21333C7.99094 23.0002 7 21.9341 7 20.6191V10.0812C7 8.76621 7.99094 7.70018 9.21333 7.70018ZM11.1111 5.9C11.1111 5.40294 11.5091 5 12 5C12.4909 5 12.8889 5.40294 12.8889 5.9V10.4C12.8889 10.8971 12.4909 11.3 12 11.3C11.5091 11.3 11.1111 10.8971 11.1111 10.4V5.9ZM17.2578 6C17.2578 5.50294 17.6558 5.1 18.1467 5.1C18.6376 5.1 19.0356 5.50294 19.0356 6V10.5C19.0356 10.9971 18.6376 11.3632 18.1467 11.3632C17.6558 11.3632 17.2578 10.9971 17.2578 10.5V6Z",
    fill: "#1976D2"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "11",
    y: "12.5",
    width: "3",
    height: "3",
    fill: "#1976D2"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "16",
    y: "12.5",
    width: "3",
    height: "3",
    fill: "#1976D2"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "11",
    y: "16.5",
    width: "3",
    height: "3",
    fill: "#1976D2"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "16",
    y: "16.5",
    width: "3",
    height: "3",
    fill: "#1976D2"
  }));
};

Event.propTypes = {
  viewBox: _propTypes.PropTypes.string
};
Event.defaultProps = {
  viewBox: '0 0 30 30'
};
var _default = Event;
exports.default = _default;